import React from "react";
import PostProfileImg from "../../../../../styles/img/post-profile-img.jpg";

export default function PostProfileImgs(props) {
    const data = [
        {
            name: "Cold Drink",
            img: "../../../../../styles/img/post-profile-img.jpg",
        },
        {
            name: "Hot Drink",
            img: "../../../../../styles/img/post-profile-img.jpg",
        },
        {
            name: "chease Cake",
            img: "../../../../../styles/img/post-profile-img.jpg",
        },
        {
            name: "chease Cake",
            img: "../../../../../styles/img/post-profile-img.jpg",
        },
        {
            name: "chease Cake",
            img: "../../../../../styles/img/post-profile-img.jpg",
        },
    ];
    return (
        <>
            <div className="sb-post-profile-img-wr">
                {data
                    .filter((item, index) => index < 3)
                    .map((item, index) => {
                        return (
                            <div key={index} className="sb-post-profile-img">
                                <img src={item.img} alt="" />
                            </div>
                        );
                    })}
                <div className="sb-post-profile-img-count">
                    +{data.length - 3}
                </div>
            </div>
        </>
    );
}
